module.exports = __webpack_public_path__ + "static/img/2.ba73e15.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/2.png
// module id = rmgk
// module chunks = 0